import React, { useState, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import CustomHeading from "./common/CustomHeading";
import CustomInput from "./common/CustomInput";
import CustomSelect from "./common/CustomSelect";
import Button from "./common/Button";
import {
  fetchGstSummaryDetails,
  // getGstAuthenticatiobByData,
  getGstAuthenticatiobByDataNew,
  // saveBusinessSection,
  saveBusinessSectionNew,
} from "../ActionCreator";
import moment from "moment";

const getDurationFromDate = (inputDate) => {
  if (!inputDate) return "";

  const [year, month, day] = inputDate.split("-").map(Number);
  const startDate = new Date(year, month - 1, day);
  const currentDate = new Date();

  // Total days difference
  const diffTime = currentDate - startDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // If less than 1 month, show days
  if (diffDays < 30) {
    return `${diffDays} day${diffDays !== 1 ? "s" : ""}`;
  }

  let years = currentDate.getFullYear() - startDate.getFullYear();
  let months = currentDate.getMonth() - startDate.getMonth();

  // Adjust months
  if (currentDate.getDate() < startDate.getDate()) {
    months--;
  }

  // Fix negative months
  if (months < 0) {
    years--;
    months += 12;
  }

  const result = [];
  if (years > 0) {
    result.push(`${years} year${years > 1 ? "s" : ""}`);
  }
  if (months > 0) {
    result.push(`${months} month${months > 1 ? "s" : ""}`);
  }

  return result.join(" ");
};

function getMiddlePan(str) {
  if (!str || str.length < 15) return "";
  return str.slice(2, -3);
}

const extractAddressDetails = (address) => {
  if (!address) {
    return {
      city: "",
      state: "",
      pincode: "",
    };
  }

  const parts = address.split(",").map((item) => item.trim());
  const pincode = parts.at(-1) || "";
  const state = parts.at(-2) || "";
  const city = parts.at(-3) || "";

  return {
    city,
    state,
    pincode,
  };
};

const normalizeConstitution = (val) => {
  if (!val) return "";
  const lower = val.toLowerCase().replace(/[^a-z0-9]/g, "");
  if (lower.includes("proprietor") || lower === "soleprop" || lower === "sole_prop") {
    return "sole_prop";
  }
  if (lower.includes("partner")) {
    return "Partnership";
  }
  if (lower === "llp" || lower.includes("limitedliability")) {
    return "llp";
  }
  if (lower.includes("pvtltd") || lower.includes("privatelimited") || lower === "pvt_ltd") {
    return "Private Limited Company";
  }
  if (lower.includes("publtd") || lower.includes("publiclimited") || lower === "pub_ltd") {
    return "Public Limited Company";
  }
  if (["sole_prop", "Partnership", "llp", "Private Limited Company", "Public Limited Company"].includes(val)) {
    return val;
  }
  return val;
};

const CorporateBusinessKYC = ({
  allDetail,
  initialData,
  setLoader,
  showPopup,
  onRefresh,
  loanAppData,
}) => {
  const [form, setForm] = useState({
    businessName: "",
    constitution: "",
    lineOfBusiness: "",
    dateOfIncorporation: "",
    industrySector: "",
    businessVintage: "",
    businessPan: "",
    panVerificationStatus: "",
    gstRegistration: "",
    gstRegistrationDate: "",
    gstVerificationStatus: "",
    msmeUdhyamNo: "",
    gstState: "",
    msmeCategory: "",
    regAddressLine: "",
    regCity: "",
    regState: "",
    regPincode: "",
    regVerificationStatus: "",
    regAddressSource: "",
    opAddressLine: "",
    opCity: "",
    opState: "",
    opPincode: "",
    opVerificationStatus: "",
    opAddressSource: "",
    geoTaggedVerified: false,
  });

  const [fetchPanNumber, setFetchPanNumber] = useState({ pan: "", data: [] });
  const [sameAsRegistered, setSameAsRegistered] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [taxpayerList, setTaxpayerList] = useState([])

  // Sync state with parent-supplied initialData
  // useEffect(() => {
  //   if (initialData || loanAppData) {
  //     setForm({
  //       businessName: loanAppData?.tradeName ?? "",
  //       constitution: normalizeConstitution(initialData?.constitution ?? loanAppData?.constitution ?? ""),
  //       lineOfBusiness: loanAppData?.lineOfBusiness ?? "",
  //       dateOfIncorporation: initialData?.dateOfIncorporation ?? "",
  //       industrySector: initialData?.industrySector ?? "",
  //       businessVintage: initialData?.businessVintage ?? "",
  //       panVerificationStatus: initialData?.panVerificationStatus ?? "",
  //       gstRegistration: loanAppData?.gstRegistrationNumber ?? "",
  //       gstRegistrationDate: loanAppData?.gstRegistrationDate
  // ? moment(loanAppData.gstRegistrationDate, "DD/MM/YYYY").format("YYYY-MM-DD")
  // : "",
  //       gstVerificationStatus: loanAppData?.gstVerificationStatus ?? "",
  //       msmeUdhyamNo: initialData?.msmeUdhyamNo ?? "",
  //       gstState: initialData?.gstState ?? "",
  //       msmeCategory: initialData?.msmeCategory ?? "",
  //       regAddressLine: initialData?.regAddressLine ?? "",
  //       regCity: initialData?.regCity ?? "",
  //       regState: initialData?.regState ?? "",
  //       regPincode: initialData?.regPincode ?? "",
  //       regVerificationStatus: initialData?.regVerificationStatus ?? "",
  //       regAddressSource: initialData?.regAddressSource ?? "",
  //       opAddressLine: initialData?.opAddressLine ?? "",
  //       opCity: initialData?.opCity ?? "",
  //       opState: initialData?.opState ?? "",
  //       opPincode: initialData?.opPincode ?? "",
  //       opVerificationStatus: initialData?.opVerificationStatus ?? "",
  //       opAddressSource: initialData?.opAddressSource ?? "",
  //       geoTaggedVerified: initialData?.geoTaggedVerified ?? false,
  //     });

  //     if (initialData?.businessPan) {
  //       setFetchPanNumber((prev) => ({
  //         ...prev,
  //         pan: initialData?.businessPan,
  //       }));
  //     }
  //   }
  // }, [initialData,loanAppData]);
  useEffect(() => {
    if (loanAppData) {
      console.log("loanAppDataloanAppData", loanAppData)
      setForm({
        businessName: loanAppData?.tradeName ?? "",
        constitution: normalizeConstitution(initialData?.constitution ?? loanAppData?.constitution ?? ""),
        lineOfBusiness: loanAppData?.lineOfBusiness ?? "",
        dateOfIncorporation: initialData?.dateOfIncorporation ?? "",
        industrySector: initialData?.industrySector ?? "",
        businessVintage: initialData?.businessVintage ?? "",
        panVerificationStatus: initialData?.panVerificationStatus ?? "",
        gstRegistration: loanAppData?.gstRegistrationNumber ?? "",
        gstRegistrationDate: loanAppData?.gstRegistrationDate
          ? moment(loanAppData.gstRegistrationDate, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
        gstVerificationStatus: loanAppData?.gstVerificationStatus ?? "",
        msmeUdhyamNo: initialData?.msmeUdhyamNo ?? "",
        gstState: initialData?.gstState ?? "",
        msmeCategory: initialData?.msmeCategory ?? "",
        regAddressLine: initialData?.regAddressLine ?? "",
        regCity: initialData?.regCity ?? "",
        regState: initialData?.regState ?? "",
        regPincode: initialData?.regPincode ?? "",
        regVerificationStatus: initialData?.regVerificationStatus ?? "",
        regAddressSource: initialData?.regAddressSource ?? "",
        opAddressLine: initialData?.opAddressLine ?? "",
        opCity: initialData?.opCity ?? "",
        opState: initialData?.opState ?? "",
        opPincode: initialData?.opPincode ?? "",
        opVerificationStatus: initialData?.opVerificationStatus ?? "",
        opAddressSource: initialData?.opAddressSource ?? "",
        geoTaggedVerified: initialData?.geoTaggedVerified ?? false,
      });


    }
  }, [loanAppData]);

  // Sync regAddressLine components (City, State, Pincode)
  useEffect(() => {
    if (form.regAddressLine) {
      const { city, state, pincode } = extractAddressDetails(form.regAddressLine);
      setForm((prev) => ({
        ...prev,
        regCity: prev.regCity || city,
        regState: prev.regState || state,
        regPincode: prev.regPincode || pincode,
      }));
    }
  }, [form.regAddressLine]);

  useEffect(() => {
    if (form.gstRegistration?.length === 15) {
      handleGStValue();
      const pan = getMiddlePan(form.gstRegistration);
      if (pan) {
        setForm((prev) => ({ ...prev, businessPan: pan }));
        setFetchPanNumber((prev) => ({ ...prev, pan }));
      }
    }
  }, [form.gstRegistration]);

  const handleChange = (e, field) => {
    const val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({
      ...prev,
      [field]: val,
    }));
  };

  const handleDirectLy = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const fetchGstSummaryDetailsAPi = () => {
    const data = {
      pan: fetchPanNumber.pan,
      consent: "Y",
    };
    setLoader(true);
    fetchGstSummaryDetails(fetchPanNumber.pan, allDetail?.userId, (callback) => {
      setLoader(false);
      if (

        callback?.status == 200 &&
        callback?.data?.result?.length > 0
      ) {
        setFetchPanNumber((prev) => ({
          ...prev,
          data: callback?.data?.result ?? [],
        }));
      } else {
        setFetchPanNumber((prev) => ({
          ...prev,
          data: "No Data Found!!!",
        }));
      }
    });
  };

  const handleGStValue = () => {
    if (!form.gstRegistration || form.gstRegistration.trim().length < 15) {
      return;
    }
    setLoader(true);
    getGstAuthenticatiobByDataNew(form.gstRegistration.trim(), (callback) => {
      setLoader(false);

      // Extract result from various possible Digitap response structures
      const result =
        callback?.data?.result?.taxpayerDetails ||
        callback?.result?.taxpayerDetails ||
        callback?.data?.taxpayerDetails ||
        callback?.taxpayerDetails ||
        callback?.data?.result ||
        callback?.result ||
        callback?.data ||
        callback;

      setTaxpayerList(callback?.data?.result?.taxpayerReturnDetails?.filingStatus ?? [])
      if (!result || typeof result !== "object") {
        console.warn("No taxpayer details found in GST callback:", callback);
        return;
      }

      // Extract Date of Incorporation / Registration & calculate vintage
      const rawDate =
        result?.dateOfIncorporation ||
        result?.rgdt ||
        result?.registrationDate ||
        result?.dtreg ||
        "";
      let formattedDate = "";
      if (rawDate) {
        const m = moment(rawDate, ["DD/MM/YYYY", "YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601]);
        formattedDate = m.isValid() ? m.format("YYYY-MM-DD") : rawDate;
      }
      const vintage = formattedDate ? getDurationFromDate(formattedDate) : "";

      // Extract Address & breakdown
      const addrStr = result?.pradr?.adr || result?.regAddressLine || "";
      const addrObj = result?.pradr?.addr || {};
      const parsed = extractAddressDetails(addrStr);
      const regCity = addrObj.dst || addrObj.loc || parsed.city || result?.regCity || "";
      const regState =
        addrObj.stcd ||
        (result?.stj ? result.stj.split(",")[0].replace(/^State\s*-\s*/i, "").trim() : "") ||
        parsed.state ||
        result?.regState ||
        "";
      const regPincode = addrObj.pncd || parsed.pincode || result?.regPincode || "";

      // Normalize Constitution
      const constitution = normalizeConstitution(result?.ctb || result?.constitution || "");

      // Extract Business / Trade Name
      const businessName =
        result?.lgnm ||
        result?.tradeName ||
        result?.trade_name ||
        result?.businessName ||
        "";

      // Extract Industry Sector / NBA
      const industrySector =
        (Array.isArray(result?.nba) ? result.nba.join(", ") : result?.nba?.[0] || result?.nba) ||
        result?.industrySector ||
        "";

      // Extract Line of Business / NTCRBS
      const lineOfBusiness = result?.ntcrbs || result?.lineOfBusiness || "";

      // Extract Business PAN
      const businessPan =
        result?.pan ||
        getMiddlePan(form.gstRegistration) ||
        result?.businessPan ||
        "";

      setForm((prev) => ({
        ...prev,
        businessName: businessName || prev.businessName,
        constitution: constitution || prev.constitution,
        lineOfBusiness: lineOfBusiness || prev.lineOfBusiness,
        dateOfIncorporation: formattedDate || prev.dateOfIncorporation,
        industrySector: industrySector || prev.industrySector,
        businessVintage: vintage || prev.businessVintage,
        businessPan: businessPan || prev.businessPan,
        panVerificationStatus: "Active",
        gstRegistration: form.gstRegistration || result?.gstin || prev.gstRegistration,
        gstRegistrationDate: formattedDate || prev.gstRegistrationDate,
        gstVerificationStatus: result?.sts || result?.gstVerificationStatus || "Active",
        msmeUdhyamNo: result?.msmeUdhyamNo || prev.msmeUdhyamNo,
        gstState: result?.stj || regState || prev.gstState,
        msmeCategory: result?.msmeCategory || prev.msmeCategory,
        regAddressLine: addrStr || prev.regAddressLine,
        regCity: regCity || prev.regCity,
        regState: regState || prev.regState,
        regPincode: regPincode || prev.regPincode,
        regVerificationStatus: result?.regVerificationStatus || prev.regVerificationStatus || "Verified",
        regAddressSource: result?.regAddressSource || prev.regAddressSource || "gst",
        opAddressLine: prev.opAddressLine || (sameAsRegistered ? addrStr : prev.opAddressLine),
        opCity: prev.opCity || (sameAsRegistered ? regCity : prev.opCity),
        opState: prev.opState || (sameAsRegistered ? regState : prev.opState),
        opPincode: prev.opPincode || (sameAsRegistered ? regPincode : prev.opPincode),
      }));
    });
  };

  const hanleDatecorpoation = (value) => {
    const vintage = getDurationFromDate(value);
    setForm((prev) => ({
      ...prev,
      dateOfIncorporation: value,
      businessVintage: vintage,
    }));
  };

  const handleSameAsRegistered = (isChecked) => {
    setSameAsRegistered(isChecked);
    if (isChecked) {
      setForm((prev) => ({
        ...prev,
        opAddressLine: prev.regAddressLine || "",
        opCity: prev.regCity || "",
        opState: prev.regState || "",
        opPincode: prev.regPincode || "",
        opVerificationStatus: prev.regVerificationStatus || "",
        opAddressSource: prev.regAddressSource || "",
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        opAddressLine: "",
        opCity: "",
        opState: "",
        opPincode: "",
        opVerificationStatus: "",
        opAddressSource: "",
      }));
    }
  };

  // Sync checkbox state with operational vs registered address match
  useEffect(() => {
    const isSame =
      form.opAddressLine === form.regAddressLine &&
      form.opCity === form.regCity &&
      form.opState === form.regState &&
      form.opPincode === form.regPincode &&
      form.opVerificationStatus === form.regVerificationStatus &&
      form.opAddressSource === form.regAddressSource &&
      form.regAddressLine;

    setSameAsRegistered(!!isSame);
  }, [
    form.opAddressLine,
    form.opCity,
    form.opState,
    form.opPincode,
    form.opVerificationStatus,
    form.opAddressSource,
    form.regAddressLine,
    form.regCity,
    form.regState,
    form.regPincode,
    form.regVerificationStatus,
    form.regAddressSource,
  ]);

  const handleSave = () => {
    setBtnLoading(true);
    saveBusinessSectionNew(
      {
        loanId: allDetail?.loanId,
        businessName: form.businessName,
        constitution: form.constitution,
        lineOfBusiness: form.lineOfBusiness,
        dateOfIncorporation: form.dateOfIncorporation,
        industrySector: form.industrySector,
        businessVintage: form.businessVintage,
        businessPan: form.businessPan,
        panVerificationStatus: form.panVerificationStatus,
        gstRegistrationNumber: form.gstRegistration,
        gstRegistrationDate: form.gstRegistrationDate,
        gstVerificationStatus: form.gstVerificationStatus,
        msmeUdhyamNo: form.msmeUdhyamNo,
        gstState: form.gstState,
        msmeCategory: form.msmeCategory,
        regAddressLine: form.regAddressLine,
        regCity: form.regCity,
        regState: form.regState,
        regPincode: form.regPincode,
        regVerificationStatus: form.regVerificationStatus,
        regAddressSource: form.regAddressSource,
        opAddressLine: form.opAddressLine,
        opCity: form.opCity,
        opState: form.opState,
        opPincode: form.opPincode,
        opVerificationStatus: form.opVerificationStatus,
        opAddressSource: form.opAddressSource,
        geoTaggedVerified: form.geoTaggedVerified,
      },
      (res) => {
        setBtnLoading(false);
        if (res?.status == 200) {
          showPopup("Business KYC saved successfully");
          onRefresh();
        } else {
          showPopup("Error saving business KYC");
        }
      },
      (err) => {
        setBtnLoading(false);
        showPopup("Error saving business KYC");
        console.error("Error saving business KYC", err);
      }
    );
  };

  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginTop: "12px",
        background: "#F9FAFB",
      }}
    >
      <CustomHeading
        title="Corporate/Business KYC"
        subtitle="Verify business entity and statutory documents."
        buttonText="Positive"
        icon={CheckCircle}
        buttonColor="#4CAF50"
        borderColor="#003BE3"
        background="#0E44E712"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <Button
          title="Save Data"
          onClick={handleSave}
          btnLoading={btnLoading}
        />
      </div>

      {/* ── Business Entity Verification ── */}
      <div style={card}>
        <h5 style={sectionTitle}>Business Entity Verification</h5>

        <div style={grid3}>
          <div>
            <CustomInput
              label={"Business Name"}
              type="text"
              placeholder=""
              value={form.businessName}
              onChange={(e) => handleChange(e, "businessName")}
            />
          </div>
          <div>
            <CustomSelect
              label={"Constitution"}
              value={form.constitution}
              onChange={(e) => handleChange(e, "constitution")}
              options={[
                { label: "Select Constitution", value: "" },
                { label: "Proprietorship", value: "sole_prop" },
                { label: "Partnership", value: "Partnership" },
                { label: "LLP", value: "llp" },
                { label: "Private Limited", value: "Private Limited Company" },
                { label: "Public Limited", value: "Public Limited Company" },
              ]}
            />
          </div>
          <div>
            <CustomInput
              label={"Line of Business"}
              type="text"
              placeholder=""
              value={form.lineOfBusiness}
              onChange={(e) => handleChange(e, "lineOfBusiness")}
            />
          </div>
        </div>

        <div style={{ ...grid3, marginTop: "20px" }}>
          <div>
            <CustomInput
              label={"Date of Incorporation"}
              type="date"
              placeholder="dd-mm-yyyy"
              value={form.dateOfIncorporation}
              onChange={(e) => hanleDatecorpoation(e.target.value)}
            />
          </div>
          <div>
            <CustomInput
              label={"Industry Sector"}
              type="text"
              placeholder="eg. Textile, IT, Food Processing"
              value={form.industrySector}
              onChange={(e) => handleChange(e, "industrySector")}
            />
          </div>

          <div>
            <CustomInput
              label={"Business Vintage (Years)"}
              type="text"
              placeholder="≥ 1 Years"
              value={form.businessVintage}
              onChange={(e) => handleChange(e, "businessVintage")}
            />
          </div>
        </div>
      </div>

      {/* ── Business Identity Documents ── */}
      <div style={card}>
        <h5 style={sectionTitle}>Business Identity Documents</h5>

        <div style={grid3}>
          <div>
            <CustomInput
              label={"Business PAN"}
              type="text"
              placeholder="1234ABCD2F"
              value={form.businessPan}
              onChange={(e) => handleChange(e, "businessPan")}
              disabled={form.businessPan?.length > 0}
            />
          </div>
          <div>
            <CustomInput
              label={"PAN Verification Status"}
              type="text"
              placeholder="-"
              value={form.panVerificationStatus}
              onChange={(e) => handleChange(e, "panVerificationStatus")}
            />
          </div>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
              <label style={{ margin: 0, fontWeight: "600", fontSize: "12px", color: "#334155" }}>
                GST Registration (GSTIN)
              </label>
              {form.gstRegistration?.trim().length === 15 && (
                <button
                  type="button"
                  onClick={() => handleGStValue()}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#024e5a",
                    fontSize: "11px",
                    fontWeight: 700,
                    cursor: "pointer",
                    padding: 0,
                    textDecoration: "underline",
                  }}
                >
                  Fetch GST Details
                </button>
              )}
            </div>
            <CustomInput
              type="text"
              placeholder="07AAACR4249P1ZX"
              value={form.gstRegistration}
              onChange={(e) => handleChange(e, "gstRegistration")}
            />
          </div>
        </div>

        <div style={{ ...grid3, marginTop: "20px" }}>
          <div>
            <CustomInput
              label={"GST Registration Date"}
              type="date"
              placeholder="dd-mm-yyyy"
              value={form.gstRegistrationDate}
              onChange={(e) => handleChange(e, "gstRegistrationDate")}
            />
          </div>

          <div>
            <CustomInput
              label={"GST Verification Status"}
              type="text"
              placeholder="-"
              value={form.gstVerificationStatus}
              onChange={(e) => handleChange(e, "gstVerificationStatus")}
            />
          </div>

          <div>
            <CustomInput
              label={"MSME/Udhyam No (if applicable)"}
              type="text"
              placeholder="-"
              value={form.msmeUdhyamNo}
              onChange={(e) => handleChange(e, "msmeUdhyamNo")}
            />
          </div>
        </div>

        <div style={{ ...grid3, marginTop: "20px" }}>
          <div>
            <CustomInput
              label={"GST State"}
              type="text"
              placeholder="-"
              value={form.gstState}
              onChange={(e) => handleChange(e, "gstState")}
            />
          </div>

          <div>
            <CustomInput
              label={"MSME Category"}
              type="text"
              placeholder="-"
              value={form.msmeCategory}
              onChange={(e) => handleChange(e, "msmeCategory")}
            />
          </div>

          <div />
        </div>
      </div>

      {/* ── Business Address Verification ── */}
      <div style={card}>
        <h5 style={sectionTitle}>Business Address Verification</h5>

        {/* Registered Office */}
        <div>
          <h6 style={subHeading}>Registered Office (As per GST)</h6>

          <div style={{ marginBottom: "14px" }}>
            <CustomInput
              label={"Address Line"}
              type="text"
              placeholder="-"
              value={form.regAddressLine}
              onChange={(e) => handleChange(e, "regAddressLine")}
              style={inputFull}
            />
          </div>

          {/* <div style={{ ...grid3, marginBottom: "14px" }}>
            <div>
              <CustomInput
                label={"City"}
                type="text"
                placeholder="-"
                value={form.regCity}
                onChange={(e) => handleChange(e, "regCity")}
              />
            </div>

            <div>
              <CustomInput
                label={"State"}
                type="text"
                placeholder="-"
                value={form.regState}
                onChange={(e) => handleChange(e, "regState")}
              />
            </div>

            <div>
              <CustomInput
                label={"Pincode"}
                type="text"
                placeholder="-"
                value={form.regPincode}
                onChange={(e) => handleChange(e, "regPincode")}
              />
            </div>
          </div> */}

          {/* <div style={grid2}>
            <div>
              <CustomSelect
                label={" Verification Document "}
                value={form.regVerificationStatus}
                onChange={(e) => handleChange(e, "regVerificationStatus")}
                options={[
                  { label: "Select Option", value: "" },
                  { label: "Utility Bill", value: "utility" },
                  { label: "Bank Statement", value: "bank" },
                ]}
              />
            </div>

            <div>
              <CustomSelect
                label={"Address Source"}
                value={form.regAddressSource}
                onChange={(e) => handleChange(e, "regAddressSource")}
                options={[
                  { label: "Select Option", value: "" },
                  { label: "Rent Agreement ", value: "rentAgreement" },
                  { label: "GST Certificate", value: "gst" },
                  { label: "Bank Statement", value: "bank" },
                  { label: "Utility Bill", value: "utility" },
                ]}
              />
            </div>
          </div> */}
        </div>

        {/* Operational Address */}
        <div style={{ marginTop: "30px" }}>
          <h6 style={subHeading}>Operational Address</h6>

          {/* Checkbox for Same as Registered Office */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "20px",
            }}
          >
            <input
              type="checkbox"
              id="sameAsRegistered"
              checked={sameAsRegistered}
              onChange={(e) => handleSameAsRegistered(e.target.checked)}
              style={{
                width: "15px",
                height: "15px",
                cursor: "pointer",
                accentColor: "#1a73e8",
                flexShrink: 0,
              }}
            />
            <label
              htmlFor="sameAsRegistered"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                color: "#686C70",
                cursor: "pointer",
                margin: 0,
                marginTop: "3px",
              }}
            >
              Same as Registered Office
            </label>
          </div>

          <div style={{ marginBottom: "14px" }}>
            <CustomInput
              label={"Address Line"}
              type="text"
              placeholder="-"
              value={form.opAddressLine}
              onChange={(e) => handleChange(e, "opAddressLine")}
              style={inputFull}
            />
          </div>

          {/* <div style={{ ...grid3, marginBottom: "14px" }}>
            <div>
              <CustomInput
                label={"City"}
                type="text"
                placeholder="-"
                value={form.opCity}
                onChange={(e) => handleChange(e, "opCity")}
              />
            </div>

            <div>
              <CustomInput
                label={"State"}
                type="text"
                placeholder="-"
                value={form.opState}
                onChange={(e) => handleChange(e, "opState")}
              />
            </div>

            <div>
              <CustomInput
                label={"Pincode"}
                type="text"
                placeholder="-"
                value={form.opPincode}
                onChange={(e) => handleChange(e, "opPincode")}
              />
            </div>
          </div>

          <div style={grid2}>
            <div>
              <CustomSelect
                label={"Verification Status"}
                value={form.opVerificationStatus}
                onChange={(e) => handleChange(e, "opVerificationStatus")}
                options={[
                  { label: "Select Option", value: "" },
                  { label: "Passport", value: "Passport" },
                  { label: "Utility Bill", value: "utility" },
                  { label: "Bank Statement", value: "bank" },
                ]}
              />
            </div>

            <div>
              <CustomSelect
                label={"Address Source"}
                value={form.opAddressSource}
                onChange={(e) => handleChange(e, "opAddressSource")}
                options={[
                  { label: "Select Option", value: "" },
                  { label: "Rent Agreement ", value: "rentAgreement" },
                  { label: "GST Certificate", value: "gst" },
                  { label: "Bank Statement", value: "bank" },
                  { label: "Utility Bill", value: "utility" },
                ]}
              />
            </div>
          </div> */}

          {/* Checkbox */}
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <input
              type="checkbox"
              id="geoTagged"
              checked={form.geoTaggedVerified}
              onChange={(e) =>
                handleChange(
                  { target: { type: "checkbox", checked: e.target.checked } },
                  "geoTaggedVerified"
                )
              }
              style={{
                width: "15px",
                height: "15px",
                cursor: "pointer",
                accentColor: "#1a73e8",
                flexShrink: 0,
              }}
            />
            <label
              htmlFor="geoTagged"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                color: "#686C70",
                cursor: "pointer",
                margin: 0,
              }}
            >
              Physical verification completed with geo-tagged photographs
            </label>
          </div> */}
        </div>
      </div>

      {/* ── GST Filing Status (from taxpayerList) ── */}
      {Array.isArray(taxpayerList) && taxpayerList.length > 0 && (
        <div style={card}>
          <h5 style={sectionTitle}>GST Filing Status</h5>

          <div
            style={{
              overflowX: "auto",
              marginTop: "15px",
              overflowY: "auto",
              maxHeight: "260px",
            }}
          >
            <table style={tableBase}>
              <thead>
                <tr>
                  {[
                    "Financial Year",
                    "Tax Period",
                    "Return Type",
                    "Date of Filing",
                    "Mode of Filing",
                    "ARN",
                    "Status",
                  ].map((h) => (
                    <th key={h} style={th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {taxpayerList.map((row, i) => {
                  const isFiled = (row?.status || "").toLowerCase() === "filed";
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #F0F0F0" }}>
                      <td style={td}>{row?.fy || "-"}</td>
                      <td style={td}>{row?.taxp || "-"}</td>
                      <td style={{ ...td, fontWeight: "600" }}>{row?.rtntype || "-"}</td>
                      <td style={td}>{row?.dof || "-"}</td>
                      <td style={td}>{row?.mof || "-"}</td>
                      <td style={td}>{row?.arn && row?.arn !== "NA" ? row.arn : "-"}</td>
                      <td
                        style={{
                          ...td,
                          color: isFiled ? "#16a34a" : "#dc2626",
                          fontWeight: "600",
                        }}
                      >
                        {row?.status || "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/* ── Business PAN Fetch GST Summary ── */}
      <div style={card}>
        <h5 style={sectionTitle}>GST Summary</h5>

        <div style={grid3}>
          <div>
            <CustomInput
              label={"PAN"}
              type="text"
              placeholder="1234ABCD2F"
              value={fetchPanNumber.pan}
              onChange={(e) => {
                setFetchPanNumber({ pan: e.target.value.toUpperCase(), data: [] });
              }}
            />
          </div>
          <div>
            <button
              style={{
                background: "#024e5a",
                color: "#fff",
                fontSize: "12px",
                fontWeight: "500",
                padding: "10px 16px",
                borderRadius: "8px",
                marginTop: "19px",
                border: "none",
                cursor: fetchPanNumber.pan?.length > 0 ? "pointer" : "no-drop",
                opacity: fetchPanNumber.pan?.length > 0 ? "1" : "0.6",
                transition: "all 0.15s ease",
              }}
              disabled={!fetchPanNumber.pan?.length}
              onClick={() => fetchGstSummaryDetailsAPi()}
            >
              Fetch
            </button>
          </div>
        </div>
        {Array.isArray(fetchPanNumber.data) && fetchPanNumber.data.length > 0 ? (
          <div
            style={{
              overflowX: "auto",
              marginTop: "15px",
              overflowY: "auto",
              height: "200px",
            }}
          >
            <table style={tableBase}>
              <thead>
                <tr>
                  {["State", "GSTIN Id", "Status"].map((h) => (
                    <th key={h} style={th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {fetchPanNumber.data.map((row, i) => {
                  const state =
                    extractAddressDetails(row?.taxpayerDetails?.pradr?.adr)?.state ||
                    (row?.taxpayerDetails?.stj
                      ? row.taxpayerDetails.stj.split(",")[0].replace(/^State\s*-\s*/i, "").trim()
                      : "") ||
                    row?.taxpayerDetails?.state ||
                    row?.state ||
                    "-";
                  const gstinId =
                    row?.taxpayerDetails?.gstin ||
                    row?.gstinId ||
                    row?.gstin ||
                    "-";
                  const status =
                    row?.taxpayerDetails?.sts ||
                    row?.authStatus ||
                    row?.status ||
                    "-";

                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #F0F0F0" }}>
                      <td style={td}>{state}</td>
                      <td style={td}>{gstinId}</td>
                      <td
                        style={{
                          ...td,
                          color: status?.toLowerCase() === "active" ? "green" : "red",
                        }}
                      >
                        {status}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ marginTop: "15px" }}>
            <h5>
              {typeof fetchPanNumber.data === "string" ? fetchPanNumber.data : ""}
            </h5>
          </div>
        )}
      </div>
    </section>
  );
};

// ── Shared styles ──────────────────────────────────────────
const card = {
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  border: "1px solid #cbd5e1",
  borderRadius: "16px",
  padding: "24px",
  boxShadow:
    "0 4px 20px -2px rgba(15, 23, 42, 0.04), 0 2px 8px -1px rgba(15, 23, 42, 0.02)",
};

const sectionTitle = {
  fontSize: "16px",
  fontWeight: "600",
  color: "#024e5a",
  margin: "0 0 18px 0",
};

const subHeading = {
  fontSize: "13px",
  fontWeight: "600",
  color: "#334155",
  margin: "0 0 14px 0",
};

const input = {
  width: "100%",
  border: "1.5px solid #cbd5e1",
  borderRadius: "10px",
  padding: "9px 11px",
  fontSize: "12px",
  fontWeight: "400",
  color: "#0f172a",
  backgroundColor: "#fff",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.15s ease",
};

const inputFull = {
  ...input,
  width: "100%",
  display: "block",
};

const grid3 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "16px",
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "16px",
};

const tableBase = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: "0 4px",
  fontSize: "13px",
};
const th = {
  padding: "11px 14px",
  textAlign: "left",
  fontWeight: "600",
  color: "#334155",
  fontSize: "12px",
  background: "#f1f5f9",
  borderBottom: "1.5px solid #cbd5e1",
};
const td = { padding: "10px 14px", color: "#0f172a", fontSize: "12px" };

export default CorporateBusinessKYC;
